import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import PageHeader from '../components/PageHeader';
import ConfigurationWarning from '../components/common/ConfigurationWarning';

// Import the tab components
import SyncOperationsTab from '../components/product-sync/SyncOperationsTab';
import SettingsTab from '../components/product-sync/SettingsTab';
import SyncedProductsTab from '../components/product-sync/SyncedProductsTab';
import FieldMappingTab from '../components/product-sync/FieldMappingTab';
import ComponentSelector from '../components/product-sync/ComponentSelector';

export default function ProductSync() {
  const location = useLocation();

  // Determine active tab based on the current URL
  const getActiveTabFromPath = () => {
    const path = location.pathname;
    if (path.includes('/product-sync/products')) return 1;
    if (path.includes('/product-sync/mapping')) return 2;
    if (path.includes('/product-sync/settings')) return 3;
    return 0; // Default to sync operations
  };

  const [activeTab, setActiveTab] = useState(getActiveTabFromPath());

  // Update active tab when the location changes
  useEffect(() => {
    setActiveTab(getActiveTabFromPath());
  }, [location]);

  return (
    <Box>
      <PageHeader
        title="Product Synchronization"
        subtitle="Sync products from your ERP system to Shopify"
      />

      <ConfigurationWarning>
        <ComponentSelector />

        {/* Render the active tab content */}
        {activeTab === 0 && <SyncOperationsTab />}
        {activeTab === 1 && <SyncedProductsTab />}
        {activeTab === 2 && <FieldMappingTab />}
        {activeTab === 3 && <SettingsTab />}
      </ConfigurationWarning>
    </Box>
  );
}
